import { useEffect, useRef } from 'react'
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom'
import { INITIAL_DATA_LAYER } from '../utils/analytics'

function useGTM() {

  const isInitialized = useRef(false)

  useEffect(() => {
    if (isInitialized.current) return

    const gtmId = 'GTM-N8LQSVFS'

    // Seed dataLayer with `lp_source` + `lander-content` BEFORE GTM loads so
    // every event the container fires (page views, clicks, etc.) carries both
    // the lander identifier and the content-variant identifier. `lander-content`
    // starts at 'default' and gets bumped to the real GB value once
    // useGrowthbook resolves (via setLanderContent).
    TagManager.initialize({ gtmId, dataLayer: INITIAL_DATA_LAYER })
    isInitialized.current = true
  }, [])
}

export default useGTM
